import React, { useCallback, useMemo } from 'react';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import style from './butttonact.module.scss';

const ButtonAct = ({
  adminDocNumId,
  adminDocStatus,
  data,
  getPopupActReport,
  popupActShow,
  types,
  setVisiblePopupSignSelected,
  selectedRows,
  modalErrorOpen
}) => {
  const selectedRowDocIds = selectedRows && selectedRows.map((el) => el.mh3 || el.docId);

  const dataButton = useMemo(() => {
    let temp = {
      style: '',
      popupAct: {
        title: '',
        type: types,
        idAct: '',
        statusId: ''
      }
    };

    if (types === 'mh1') {
      // Акт не сформирован mh1
      if (data.data.mh1DocStatus === 1
      || (adminDocStatus && adminDocStatus === 1)) {
        temp = {
          ...temp,
          style: style.buttonNotStart,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textCreateAct} №${data.value} ?`,
            idAct: adminDocNumId || data.data.mh1NumId,
            statusId: adminDocStatus || data.data.mh1DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.mh1DocStatus === 2
        || (adminDocStatus && adminDocStatus === 2)) {
        temp = {
          ...temp,
          style: style.buttonNotSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct1Left} №${data.value} ${formatMessage('textModal').textBailorSendAct1Right}`,
            idAct: adminDocNumId || data.data.mh1NumId,
            statusId: adminDocStatus || data.data.mh1DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.mh1DocStatus === 3
        || (adminDocStatus && adminDocStatus === 3)) {
        temp = {
          ...temp,
          style: style.buttonSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ?`,
            // eslint-disable-next-line max-len
            // title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ${formatMessage('textModal').textBailorSendAct2Right}`,
            idAct: adminDocNumId || data.data.mh1NumId,
            statusId: adminDocStatus || data.data.mh1DocStatus
          }
        };
      }
      if (data.data.mh1DocStatus === 4
        || (adminDocStatus && adminDocStatus === 4)) {
        temp = {
          ...temp,
          style: style.buttonSendOk,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ?`,
            idAct: adminDocNumId || data.data.mh1NumId,
            statusId: adminDocStatus || data.data.mh1DocStatus
          }
        };
      }
    }
    if (types === 'mh3') {
      // Акт не сформирован mh3
      if (data.data.mh3DocStatus === 1
        || (adminDocStatus && adminDocStatus === 1)) {
        temp = {
          ...temp,
          style: style.buttonNotStart,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textCreateAct} №${data.value} ?`,
            idAct: adminDocNumId || data.data.mh3NumId,
            statusId: adminDocStatus || data.data.mh3DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.mh3DocStatus === 2
        || (adminDocStatus && adminDocStatus === 2)) {
        temp = {
          ...temp,
          style: style.buttonNotSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct1Left} №${data.value} ${formatMessage('textModal').textBailorSendAct1Right}`,
            idAct: adminDocNumId || data.data.mh3NumId,
            statusId: adminDocStatus || data.data.mh3DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.mh3DocStatus === 3
        || (adminDocStatus && adminDocStatus === 3)) {
        temp = {
          ...temp,
          style: style.buttonSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ?`,
            // eslint-disable-next-line max-len
            // title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ${formatMessage('textModal').textBailorSendAct2Right}`,
            idAct: adminDocNumId || data.data.mh3NumId,
            statusId: adminDocStatus || data.data.mh3DocStatus
          }
        };
      }
      if (data.data.mh3DocStatus === 4
        || (adminDocStatus && adminDocStatus === 4)) {
        temp = {
          ...temp,
          style: style.buttonSendOk,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ?`,
            idAct: adminDocNumId || data.data.mh3NumId,
            statusId: adminDocStatus || data.data.mh3DocStatus
          }
        };
      }
    }
    if (types === 'm15' || types === 'm4') {
      // Акт не сформирован m15
      if (data.data.m15DocStatus === 1
        || (adminDocStatus && adminDocStatus === 1)) {
        temp = {
          ...temp,
          style: style.buttonNotStart,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textCreateInvoice} №${data.value} ?`,
            idAct: adminDocNumId || data.data.m15NumId,
            statusId: adminDocStatus || data.data.m15DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.m15DocStatus === 2
        || (adminDocStatus && adminDocStatus === 2)) {
        temp = {
          ...temp,
          style: style.buttonNotSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice1Left} №${data.value} ${formatMessage('textModal').textBailorSendInvoice1Right}`,
            idAct: adminDocNumId || data.data.m15NumId,
            statusId: adminDocStatus || data.data.m15DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.m15DocStatus === 3
        || (adminDocStatus && adminDocStatus === 3)) {
        temp = {
          ...temp,
          style: style.buttonSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice2Left} №${data.value} ?`,
            // eslint-disable-next-line max-len
            // title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ${formatMessage('textModal').textBailorSendAct2Right}`,
            idAct: adminDocNumId || data.data.m15NumId,
            statusId: adminDocStatus || data.data.m15DocStatus,
            numberAct: data.value
          }
        };
      }
      if (data.data.m15DocStatus === 4
        || (adminDocStatus && adminDocStatus === 4)) {
        temp = {
          ...temp,
          style: style.buttonSendOk,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice2Left} №${data.value} ?`,
            idAct: adminDocNumId || data.data.m15NumId,
            statusId: adminDocStatus || data.data.m15DocStatus,
            numberAct: data.value
          }
        };
      }
    }
    if (types === 'm15B') {
      // Акт не сформирован m15b
      if (data.data.m15bDocStatus === 1
        || (adminDocStatus && adminDocStatus === 1)) {
        temp = {
          ...temp,
          style: style.buttonNotStart,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textCreateInvoice} №${data.value} ?`,
            idAct: adminDocNumId || data.data.m15bNumId,
            statusId: adminDocStatus || data.data.m15bDocStatus
          }
        };
      }
      if (data.data.m15bDocStatus === 2
        || (adminDocStatus && adminDocStatus === 2)) {
        temp = {
          ...temp,
          style: style.buttonNotSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice1Left} №${data.value} ${formatMessage('textModal').textBailorSendInvoice1Right}`,
            idAct: adminDocNumId || data.data.m15bNumId,
            statusId: adminDocStatus || data.data.m15bDocStatus
          }
        };
      }
      if (data.data.m15bDocStatus === 3
        || (adminDocStatus && adminDocStatus === 3)) {
        temp = {
          ...temp,
          style: style.buttonSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice2Left} №${data.value} ?`,
            // eslint-disable-next-line max-len
            // title: `${formatMessage('textModal').textBailorSendAct2Left} №${data.value} ${formatMessage('textModal').textBailorSendAct2Right}`,
            idAct: adminDocNumId || data.data.m15bNumId,
            statusId: adminDocStatus || data.data.m15bDocStatus
          }
        };
      }
      if (data.data.m15bDocStatus === 4
        || (adminDocStatus && adminDocStatus === 4)) {
        temp = {
          ...temp,
          style: style.buttonSendOk,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textBailorSendInvoice2Left} №${data.value} ?`,
            idAct: adminDocNumId || data.data.m15bNumId,
            statusId: adminDocStatus || data.data.m15bDocStatus
          }
        };
      }
    }
    if (types === 'tn') {
      if (data.data.docStatus === 1
        || (adminDocStatus && adminDocStatus === 1)) {
        console.log('data =', data);
        temp = {
          ...temp,
          style: style.buttonNotStart,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textCreateTn} №${data.value} ?`,
            idAct: adminDocNumId || data.data.ttnDocumentNumId,
            statusId: adminDocStatus || data.data.docStatus
          }
        };
      }
      if (data.data.docStatus === 2
        || (adminDocStatus && adminDocStatus === 2)) {
        temp = {
          ...temp,
          style: style.buttonNotSend,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textConfirmTn} №${data.value}`,
            idAct: adminDocNumId || data.data.ttnDocumentNumId,
            statusId: adminDocStatus || data.data.docStatus
          }
        };
      }
      if (data.data.docStatus === 4
        || (adminDocStatus && adminDocStatus === 4)) {
        temp = {
          ...temp,
          style: style.buttonSendOk,
          popupAct: {
            ...temp.popupAct,
            title: `${formatMessage('textModal').textOpenConfirmedTn} №${data.value} ?`,
            idAct: adminDocNumId || data.data.ttnDocumentNumId,
            statusId: adminDocStatus || data.data.docStatus
          }
        };
      }
    }
    return temp;
  }, [adminDocNumId, adminDocStatus, data, types]);

  const onClick = useCallback(() => {
    if (types === 'actAdmin') {
      // eslint-disable-next-line max-len
      // popupActShow({ title: '', type: data.data.docTypeNumId, idAct: data.data.docNumId, statusId: data.data.docStatus });
      getPopupActReport({ idAct: data.data.docNumId, statusId: 2 });
    } else if (
      selectedRows
      && selectedRows.length > 1
      && selectedRowDocIds.includes(data.data.docId || data.data.mh3)
    ) {
      let signActs = true;
      selectedRows.forEach((el) => {
        if (
          (el.docStatus && el.docStatus !== 2)
          || (el.mh3DocStatus && el.mh3DocStatus !== 2)
        ) {
          signActs = false;
        }
      });

      if (signActs) {
        setVisiblePopupSignSelected(true);
      } else {
        modalErrorOpen({
          message: `${formatMessage('textModal').textActStatus}`,
          techInfo: '',
          types: 'info',
          title: formatMessage('textError').warning
        });
      }
    } else {
      popupActShow(dataButton.popupAct);
    }
  }, [
    types,
    selectedRows,
    selectedRowDocIds,
    data.data.docId,
    data.data.mh3,
    data.data.docNumId,
    getPopupActReport,
    setVisiblePopupSignSelected,
    modalErrorOpen,
    popupActShow,
    dataButton.popupAct
  ]);

  return (
    <Button text={data.value}
            elementAttr={{ class: `${style.button}  ${dataButton.style}` }}
            // elementAttr={{ class: style.button }}
            type="default"
            stylingMode="text"
            onClick={onClick}
    />
  );
};

export default React.memo(ButtonAct);
